import { Injectable } from '@angular/core';
import { EmployeeOnboardingService } from 'app/services/employee-onboarding.service';
import 'rxjs/add/operator/do';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { SkillPracticeTaskResponse, SkillPracticeTaskType } from '../models/skill-learning.model';
import { SKILL_PRACTICE_TASK_TYPE } from '../options/skill-learning.option';
import { SKILL_PRACTICE_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillPracticeApiService {

  constructor(private http: Http, private onboarding: EmployeeOnboardingService) {}

  startPracticeLevel(
    specializationId: string,
    level: number,
    taskType: SkillPracticeTaskType = SKILL_PRACTICE_TASK_TYPE.PRACTICE,
  ): Observable<SkillPracticeTaskResponse> {
    return this.http
      .post(SKILL_PRACTICE_API.START(specializationId, level, taskType), null)
      .map(response => response.json() as SkillPracticeTaskResponse)
      .do(() => this.onboarding.invalidate());
  }

  fetchPracticeTask(
    specializationId: string,
    level: number,
    taskType: SkillPracticeTaskType = SKILL_PRACTICE_TASK_TYPE.PRACTICE,
  ): Observable<SkillPracticeTaskResponse> {
    return this.http
      .get(SKILL_PRACTICE_API.TASK(specializationId, level, taskType))
      .map(response => response.json() as SkillPracticeTaskResponse)
      .do(() => this.onboarding.invalidate());
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-practice-api.service.ts